import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-up-right-icon',
  templateUrl: './navigation-up-right.component.html'
})
export class NavigationUpRightComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
